import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/nucleus-logo-1.svg'


const _hoisted_1 = { class: "p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("img", {
      class: "ml-auto mr-auto w-72",
      src: _imports_0,
      alt: "Nucleus Logo SVG"
    }, null, -1)
  ])))
}